const centres = [{
  sys: {
    id: '3dCR177u6QSE6yUk2iYCCk'
  },
  title: 'Mt Druitt',
  suburb: 'Mt Druitt',
  state: 'NSW',
  longitude: 150.820282,
  latitude: -33.766408,
  status: 'Open',
  country: 'Australia',
  slug: 'mtdruitt',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '4DzJL8FfxS8euksqmS2AC0'
  },
  title: 'Eastgardens',
  suburb: 'Eastgardens',
  state: 'NSW',
  longitude: 151.224327,
  latitude: -33.944814,
  status: 'Open',
  country: 'Australia',
  slug: 'eastgardens',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '5L82lLe89ysCiksiY0WISc'
  },
  title: 'Southland',
  suburb: 'Cheltenham',
  state: 'VIC',
  longitude: 145.052916,
  latitude: -37.958198,
  status: 'Open',
  country: 'Australia',
  slug: 'southland',
  timeZone: 'Australia/Melbourne'
}, {
  sys: {
    id: 'VdBZiQxZaCcoee6K4y4K0'
  },
  title: 'Parramatta',
  suburb: 'Parramatta',
  state: 'NSW',
  longitude: 151.001878,
  latitude: -33.817627,
  status: 'Open',
  country: 'Australia',
  slug: 'parramatta',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '2Ot4If8sco2w80CO0o86IS'
  },
  title: 'Belconnen',
  suburb: 'Belconnen',
  state: 'ACT',
  longitude: 149.065957,
  latitude: -35.238416,
  status: 'Open',
  country: 'Australia',
  slug: 'belconnen',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '5JTDRSJsXe6MaemuweQqO6'
  },
  title: 'Bondi Junction',
  suburb: 'Bondi Junction',
  state: 'NSW',
  longitude: 151.250815,
  latitude: -33.891289,
  status: 'Open',
  country: 'Australia',
  slug: 'bondijunction',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '5rLQgVq39CUC208qM4sgMc'
  },
  title: 'Carousel',
  suburb: 'Cannington',
  state: 'WA',
  longitude: 115.937879,
  latitude: -32.019151,
  status: 'Open',
  country: 'Australia',
  slug: 'carousel',
  timeZone: 'Australia/Perth'
}, {
  sys: {
    id: '6puUURXi2A6eKI8GOOqW6a'
  },
  title: 'Chatswood',
  suburb: 'Chatswood',
  state: 'NSW',
  longitude: 151.183758,
  latitude: -33.797165,
  status: 'Open',
  country: 'Australia',
  slug: 'chatswood',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: 'DbmvQ5QwmWYe0E2oMCCOW'
  },
  title: 'Coomera',
  suburb: 'Coomera',
  state: 'QLD',
  longitude: 153.318686,
  latitude: -27.855015,
  status: 'Open',
  country: 'Australia',
  slug: 'coomera',
  timeZone: 'Australia/Brisbane'
}, {
  sys: {
    id: '72KbRfFBuwcQUgSmmk4aEe'
  },
  title: 'Doncaster',
  suburb: 'Doncaster',
  state: 'VIC',
  longitude: 145.12562,
  latitude: -37.785423,
  status: 'Open',
  country: 'Australia',
  slug: 'doncaster',
  timeZone: 'Australia/Melbourne'
}, {
  sys: {
    id: '2n09Ssd1S8K4c2GOqAcsCO'
  },
  title: 'Hurstville',
  suburb: 'Hurstville',
  state: 'NSW',
  longitude: 151.105253,
  latitude: -33.966258,
  status: 'Open',
  country: 'Australia',
  slug: 'hurstville',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: 'XEbqtX1OI8Q4qIw0AEI0o'
  },
  title: 'Miranda',
  suburb: 'Miranda',
  state: 'NSW',
  longitude: 151.099835,
  latitude: -34.034494,
  status: 'Open',
  country: 'Australia',
  slug: 'miranda',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '60Fs97eDDi82qWy48OmggA'
  },
  title: 'North Lakes',
  suburb: 'North Lakes',
  state: 'QLD',
  longitude: 153.017875,
  latitude: -27.242098,
  status: 'Open',
  country: 'Australia',
  slug: 'northlakes',
  timeZone: 'Australia/Brisbane'
}, {
  sys: {
    id: '1Jyx9i1X0gGSQyAQwkkUkG'
  },
  title: 'Penrith',
  suburb: 'Penrith',
  state: 'NSW',
  longitude: 150.692,
  latitude: -33.751,
  status: 'Open',
  country: 'Australia',
  slug: 'penrith',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '44TsnoRpV6qgSiUGku6smk'
  },
  title: 'Chermside',
  suburb: 'Chermside',
  state: 'QLD',
  longitude: 153.032145,
  latitude: -27.384408,
  status: 'Open',
  country: 'Australia',
  slug: 'chermside',
  timeZone: 'Australia/Brisbane'
}, {
  sys: {
    id: '7KWb3UbUfm2wcwKCCa04wA'
  },
  title: 'Liverpool',
  suburb: 'Liverpool',
  state: 'NSW',
  longitude: 150.923488,
  latitude: -33.919072,
  status: 'Open',
  country: 'Australia',
  slug: 'liverpool',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '5RwyGvwN8IggwwwWAwymo2'
  },
  title: 'Burwood',
  suburb: 'Burwood',
  state: 'NSW',
  longitude: 151.105889,
  latitude: -33.874545,
  status: 'Open',
  country: 'Australia',
  slug: 'burwood',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '3dWNP5m0LLFrt7SGnxMa6E'
  },
  title: 'Booragoon',
  suburb: 'Booragoon',
  state: 'WA',
  longitude: 115.83547,
  latitude: -32.03408,
  status: 'Open',
  country: 'Australia',
  slug: 'booragoon',
  timeZone: 'Australia/Perth'
}, {
  sys: {
    id: '4HGb4CrP7q6UqeyAGIImEK'
  },
  title: 'Knox',
  suburb: 'Wantirna South',
  state: 'VIC',
  longitude: 145.237885,
  latitude: -37.868891,
  status: 'Open',
  country: 'Australia',
  slug: 'knox',
  timeZone: 'Australia/Melbourne'
}, {
  sys: {
    id: '4CxHLGAEr6wCqKYCGgceY2'
  },
  title: 'Marion',
  suburb: 'Oaklands Park',
  state: 'SA',
  longitude: 138.544763,
  latitude: -35.016266,
  status: 'Open',
  country: 'Australia',
  slug: 'marion',
  timeZone: 'Australia/Adelaide'
}, {
  sys: {
    id: '6PKkNkciKAk8cWco0qUqMk'
  },
  title: 'Plenty Valley',
  suburb: 'Mill Park',
  state: 'VIC',
  longitude: 145.071586,
  latitude: -37.651294,
  status: 'Open',
  country: 'Australia',
  slug: 'plentyvalley',
  timeZone: 'Australia/Melbourne'
}, {
  sys: {
    id: '2eXxmMd01G0Woiky6kEmmy'
  },
  title: 'Hornsby',
  suburb: 'Hornsby',
  state: 'NSW',
  longitude: 151.10064,
  latitude: -33.704013,
  status: 'Open',
  country: 'Australia',
  slug: 'hornsby',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '2qR0cugfMUC6SyicgMEios'
  },
  title: 'Warringah Mall',
  suburb: 'Brookvale',
  state: 'NSW',
  longitude: 151.26631,
  latitude: -33.768008,
  status: 'Open',
  country: 'Australia',
  slug: 'warringahmall',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: 'K81skQKvSwAeEqkmIG2Kc'
  },
  title: 'Tuggerah',
  suburb: 'Tuggerah',
  state: 'NSW',
  longitude: 151.412113,
  latitude: -33.3084,
  status: 'Open',
  country: 'Australia',
  slug: 'tuggerah',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '3X0qIsAwoEMaaYaQWE8ykE'
  },
  title: 'Woden',
  suburb: 'Woden',
  state: 'ACT',
  longitude: 149.085141,
  latitude: -35.346482,
  status: 'Open',
  country: 'Australia',
  slug: 'woden',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: 'G54dC7D0MEmgS0ekOmikY'
  },
  title: 'Helensvale',
  suburb: 'Helensvale',
  state: 'QLD',
  longitude: 153.336062,
  latitude: -27.925977,
  status: 'Open',
  country: 'Australia',
  slug: 'helensvale',
  timeZone: 'Australia/Brisbane'
}, {
  sys: {
    id: '3XzgZCuvwcEUeiSgya86wq'
  },
  title: 'Innaloo',
  suburb: 'Innaloo',
  state: 'WA',
  longitude: 115.799797,
  latitude: -31.901307,
  status: 'Open',
  country: 'Australia',
  slug: 'innaloo',
  timeZone: 'Australia/Perth'
}, {
  sys: {
    id: '5WNqJNdDoIUQgIAIwq0Uoi'
  },
  title: 'West Lakes',
  suburb: 'West Lakes',
  state: 'SA',
  longitude: 138.491145,
  latitude: -34.880151,
  status: 'Open',
  country: 'Australia',
  slug: 'westlakes',
  timeZone: 'Australia/Adelaide'
}, {
  sys: {
    id: '118xu4tnEQM2WgEo2EmkYc'
  },
  title: 'Kotara',
  suburb: 'Kotara',
  state: 'NSW',
  longitude: 151.711932,
  latitude: -32.942272,
  status: 'Open',
  country: 'Australia',
  slug: 'kotara',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '2BBiYp0xKI6ckwAeMiGMEA'
  },
  title: 'Tea Tree Plaza',
  suburb: 'Modbury',
  state: 'SA',
  longitude: 138.69136,
  latitude: -34.83126,
  status: 'Open',
  country: 'Australia',
  slug: 'teatreeplaza',
  timeZone: 'Australia/Adelaide'
}, {
  sys: {
    id: 'hN2wQnhKLYooCYqkGMQaG'
  },
  title: 'Whitford City',
  suburb: 'Hillarys',
  state: 'WA',
  longitude: 115.749855,
  latitude: -31.796999,
  status: 'Open',
  country: 'Australia',
  slug: 'whitfordcity',
  timeZone: 'Australia/Perth'
}, {
  sys: {
    id: '5X6fq3y62WyoMeESQIMqEu'
  },
  title: 'Carindale',
  suburb: 'Carindale',
  state: 'QLD',
  longitude: 153.101615,
  latitude: -27.502771,
  status: 'Open',
  country: 'Australia',
  slug: 'carindale',
  timeZone: 'Australia/Brisbane'
}, {
  sys: {
    id: '4KuLmX9oIMUMKmmwAE4omQ'
  },
  title: 'Garden City',
  suburb: 'Upper Mt Gravatt',
  state: 'QLD',
  longitude: 153.082368,
  latitude: -27.56302,
  status: 'Open',
  country: 'Australia',
  slug: 'gardencity',
  timeZone: 'Australia/Brisbane'
}, {
  sys: {
    id: '3oAbNiQ3fWg4e8YWy0eeOA'
  },
  title: 'Fountain Gate',
  suburb: 'Fountain Gate',
  state: 'VIC',
  longitude: 145.303739,
  latitude: -38.017093,
  status: 'Open',
  country: 'Australia',
  slug: 'fountaingate',
  timeZone: 'Australia/Melbourne'
}, {
  sys: {
    id: 'CueMbAae2W2wUKESSW66o'
  },
  title: 'Sydney',
  suburb: 'Sydney',
  state: 'NSW',
  longitude: 151.207735,
  latitude: -33.870371,
  status: 'Open',
  country: 'Australia',
  slug: 'sydney',
  timeZone: 'Australia/Sydney'
}, {
  sys: {
    id: '5vXhSUhCrC4y42o860quiI'
  },
  title: 'Geelong',
  suburb: 'Geelong',
  state: 'VIC',
  longitude: 144.362506,
  latitude: -38.14656,
  status: 'Open',
  country: 'Australia',
  slug: 'geelong',
  timeZone: 'Australia/Melbourne'
}, {
  sys: {
    id: '6L8KCC5LkkUIACcYAK0WcA'
  },
  title: 'Airport West',
  suburb: 'Airport West',
  state: 'VIC',
  longitude: 144.885268,
  latitude: -37.713985,
  status: 'Open',
  country: 'Australia',
  slug: 'airportwest',
  timeZone: 'Australia/Melbourne'
}];
export default centres;